import React, {CSSProperties, FC} from 'react';

import {cn} from '../../../../utils';

export type ArrowIconDirection = 'right' | 'left' | 'up' | 'down';

type OwnProps = {
  direction?: ArrowIconDirection;
  size?: number;
  color?: string;
  className?: string;
  style?: CSSProperties;
  title?: string;
};

type Props = OwnProps & Omit<React.SVGProps<SVGSVGElement>, keyof OwnProps | 'color'>;

const rotationByDirection: Record<ArrowIconDirection, number> = {
  right: 0,
  down: 90,
  left: 180,
  up: 270,
};

const ArrowIcon: FC<Props> = ({
  direction = 'right',
  size = 24,
  color = 'var(--primary-green-new)',
  className,
  style,
  title = 'Arrow',
  ...svgProps
}) => {
  const rotate = rotationByDirection[direction];
  return (
    <svg
      className={cn(className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      style={{width: size, height: size, color, ...style}}
      {...svgProps}
    >
      <g transform={rotate === 0 ? undefined : `rotate(${rotate} 12 12)`}>
        <path
          d="M20 12L20.3536 11.6464L20.7071 12L20.3536 12.3536L20 12ZM5 12.5C4.72386 12.5 4.5 12.2761 4.5 12C4.5 11.7239 4.72386 11.5 5 11.5V12V12.5ZM14 6L14.3536 5.64645L20.3536 11.6464L20 12L19.6464 12.3536L13.6464 6.35355L14 6ZM20 12L20.3536 12.3536L14.3536 18.3536L14 18L13.6464 17.6464L19.6464 11.6464L20 12ZM20 12V12.5H5V12V11.5H20V12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default ArrowIcon;
